import { useContext } from 'react';

import { TenantAuthContext } from './TenantAuthContext';

export const useTenantAuth = () => {
  const context = useContext(TenantAuthContext);
  if (context === undefined) {
    throw new Error('useTenantAuth must be used within a TenantAuthProvider');
  }
  return context;
};
